import {useTable, useSortBy, usePagination, useFilters, useGlobalFilter,} from "react-table";
import React, { useState, useEffect } from "react";
import { GlobalFilter } from "./buildingEventsTable";
import Map from "../../components/SelectableMap";
import { LuCirclePower } from "react-icons/lu"; // power icon
import { IoMdRefreshCircle } from "react-icons/io"; // refresh icon
import { FaUnlock,FaLock } from "react-icons/fa"; // unlock icon
import { IoCloudOffline } from "react-icons/io5"; // offline icon
import { HiOutlineStatusOnline } from "react-icons/hi"; // online icon
import { ImFire } from "react-icons/im";
import { IconContext } from "react-icons";
import { PiCookingPotFill } from "react-icons/pi";
import { FaPlug } from "react-icons/fa";
import { RotatingLines } from "react-loader-spinner";
import Toggle from "react-toggle";
import "react-toggle/style.css";

function Loader() {
  return (
    <RotatingLines
      strokeColor="grey"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  );
}

export default function UnitEventsTable(props) {
    const result = props.result;
    const setResult = props.setResult;
  const [tableUpdateFlag, setTableUpdateFlag] = useState(false);
  const [buttonStates, setButtonStates] = useState([
    { isPressed: false, isHovered: false }, // State for button 1
    { isPressed: false, isHovered: false }, // State for button 2
    { isPressed: false, isHovered: false }, // State for button 3
    // ... more buttons
  ]);
    const [loading, setLoading] = useState(true);

    const CtsConfig = {
      TenantId: "9504ce9e-b458-4794-8d12-653589cfe2b1",
      GroupId: "a1a7b320-acc1-4e75-be64-e6cb6c1fd7b4",
      CTSConfiguration: {
        "Dashboard.unitEventsPage": {
          Table: {
            Columns: {
              IsPCOconnected: {
                ColumnNumber: 0,
                relativePosition: "blah",
                isVisible: true,
              },
            },
          },
        },
      },
    };

    useEffect(() => {      
        console.log("result ", result.length);
        setTimeout(() => {
          setLoading(false);
        }
        , 500);
    }, [
      tableUpdateFlag
    ]); 

  const center = props.building.LatLong;

  var columns = React.useMemo(
    () => [
      {
        Header: "Unit",
        accessor: "UnitNumber", // accessor is the "key" in the data
        filter: "fuzzyText",
        isVisible: true,
      },
      {
        Header: "Sensor Connection",
        accessor: "Status", // accessor is the "key" in the data
        Cell: ({ value }) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center", // Vertically center content
                gap: "8px", // Space between image and text
                color: value === "Online" ? "green" : "red",
                fontWeight: "bold",
              }}
            >
              <span>
                {value === "Online" ? (
                  <HiOutlineStatusOnline
                    style={{ width: "24px", height: "24px" }}
                  />
                ) : (
                  <IoCloudOffline style={{ width: "24px", height: "24px" }} />
                )}
              </span>
              <span>{value}</span>
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "PCO connection",
        accessor: "isPCOconnected", // accessor is the "key" in the data
        Cell: ({ row }) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center", // Vertically center content
                gap: "8px", // Space between image and text
                color:
                  row.original.Status === "Online"
                    ? row.original.isPCOconnected === "YES"
                      ? "green"
                      : "red"
                    : "red",
                fontWeight: "bold",
              }}
            >
              <span>
                {row.original.Status === "Online" ? (
                  row.original.isPCOconnected === "YES" ? (
                    <HiOutlineStatusOnline
                      style={{ width: "24px", height: "24px" }}
                    />
                  ) : (
                    <IoCloudOffline style={{ width: "24px", height: "24px" }} />
                  )
                ) : (
                  <IoCloudOffline style={{ width: "24px", height: "24px" }} />
                )}
              </span>
              <span>
                {row.original.Status === "Online"
                  ? row.original.isPCOconnected === "YES"
                    ? "Online"
                    : "Offline"
                  : "Offline"}
              </span>
            </div>
          );
        },
        isVisible:
          CtsConfig?.CTSConfiguration["Dashboard.unitEventsPage"]?.Table
            ?.Columns?.IsPCOconnected?.isVisible,
      },
      {
        Header: "Stove Power",
        accessor: "TurnOffStove", // accessor is the "key" in the data
        Cell: ({ row }) => {
          const [isPressed, setIsPressed] = React.useState(false);
          const [isHovered, setIsHovered] = React.useState(false);

          const buttonStyles = {
            backgroundColor:
              row.original.Status === "Online"
                ? row.original.isPCOconnected === "YES"
                  ? row.original.stoveStatus === "ON"
                    ? "green"
                    : "red"
                  : "green"
                : "grey",
            color: "white",
            display: "inline-flex", // Important for inline alignment
            alignItems: "center", // Vertically center content
            gap: "8px", // Space between image and text
            fontWeight: "bold",
            border: "none",
            padding: "5px 10px",
            cursor: "pointer",
            borderRadius: "5px",
            //              display: "inline-block",
            width: "100%",
            transition: "all 0.1s ease", // Add transition here
            boxShadow:
              "4px 4px 8px rgba(0, 0, 0, 0.9), 1px 1px 0px rgba(255, 255, 255, 0.2) inset",
          };

          const activeStyles = {
            transform: "translateY(2px)",
            boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.2) inset", // Or adjust as needed
          };

          const hoverStyles = {
            boxShadow:
              "5px 5px 10px rgba(0, 0, 0, 1), 2px 2px 0px rgba(255, 255, 255, 0.3) inset",
            backgroundColor:
              row.original.Status === "Online"
                ? row.original.stoveStatus === "ON"
                  ? "#45a049"
                  : "#c53c2f"
                : "grey", // Darker green/red on hover
          };
          return (
            <div
              style={{
                padding: "0",
                border: "none",
                overflow: "visible",
                textAlign: "center",
              }}
            >
              {" "}
              {/* Style the cell */}
              <label>
                <Toggle
                  disabled={
                    row.original.Status !== "Online" ||
                    row.original.stoveStatus !== "ON" ||
                    row.original.isPCOconnected === "NO"
                  }
                  checked={
                    row.original.Status === "Online" &&
                    row.original.stoveStatus === "ON"
                  }
                  style={{
                    ...buttonStyles,
                    ...(isPressed ? activeStyles : {}),
                    ...(isHovered ? hoverStyles : {}),
                    cursor: `${
                      row.original.Status === "Online"
                        ? row.original.isPCOconnected === "YES"
                          ? row.original.stoveStatus === "ON"
                            ? "pointer"
                            : "not-allowed"
                          : "not-allowed"
                        : "not-allowed"
                    }`,
                  }}
                  onMouseDown={() => setIsPressed(true)}
                  onMouseUp={() => setIsPressed(false)}
                  onMouseLeave={() => {
                    setIsPressed(false);
                    setIsHovered(false);
                  }}
                  onMouseEnter={() => setIsHovered(true)} // Set isHovered to true on mouse enter
                  icons={row.original.Status === "Online" ? false : true}
                  onChange={() => handleTurnOffStove(row.original.SensorID)}
                />
              </label>
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "Unlock Stove",
        accessor: "StoveRemoteUnlock", // accessor is the "key" in the data
        Cell: ({ row }) => {
          const [isPressed, setIsPressed] = React.useState(false);
          const [isHovered, setIsHovered] = React.useState(false);
          const buttonStyles = {
            opacity:
              row.original.Status === "Online" &&
              row.original.isPCOconnected === "YES" &&
              row.original.stoveStatus === "OFF" &&
              row.original.IsStoveRemoteUnlocked === "LOCKED"
                ? 1
                : 0.3,
            display: "inline", // Important for inline alignment
            color: "black",
            padding: "7px 7px",
            cursor: "pointer",
            borderRadius: "5px",
            transition: "all 0.1s ease", // Add transition here
            boxShadow:
              "2px 2px 4px rgba(0, 0, 0, 0.9), 1px 1px 0px rgba(255, 255, 255, 0.2) inset",
          };

          const activeStyles = {
            transform: "translateY(2px)",
            boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.2) inset", // Or adjust as needed
          };

          const hoverStyles = {
            boxShadow:
              "5px 5px 10px rgba(0, 0, 0, 1), 2px 2px 0px rgba(255, 255, 255, 0.3) inset",
          };
          //         console.log(`row: ${row.original.IsStoveRemoteUnlocked}`);
          return (
            <div
              style={{
                padding: "0",
                border: "none",
                overflow: "visible",
                textAlign: "center",
              }}
            >
              {" "}
              {/* Style the cell */}
              <button
                disabled={
                  row.original.Status !== "Online" ||
                  row.original.isPCOconnected !== "YES" ||
                  row.original.IsStoveRemoteUnlocked === "UNLOCKED"
                }
                //     disabled={false}
                style={{
                  ...buttonStyles,
                  ...(isPressed ? activeStyles : {}),
                  ...(isHovered ? hoverStyles : {}),
                  cursor: `${
                    row.original.Status === "Online"
                      ? row.original.isPCOconnected === "YES"
                        ? row.original.stoveStatus === "OFF"
                          ? row.original.IsStoveRemoteUnlocked === "LOCKED"
                            ? "pointer"
                            : "not-allowed"
                          : "not-allowed"
                        : "not-allowed"
                      : "not-allowed"
                  }`,
                }}
                onMouseDown={() => setIsPressed(true)}
                onMouseUp={() => setIsPressed(false)}
                onMouseLeave={() => {
                  setIsPressed(false);
                  setIsHovered(false);
                }}
                onMouseEnter={() => setIsHovered(true)} // Set isHovered to true on mouse enter
                onClick={() => handleStoveRemoteUnlock(row.original.SensorID)}
              >
                {row.original.Status === "Online" ? (
                  row.original.isPCOconnected === "YES" ? (
                    row.original.stoveStatus === "OFF" ? (
                      row.original.IsStoveRemoteUnlocked === "UNLOCKED" ? (
                        <FaUnlock style={{ width: "24px", height: "24px" }} />
                      ) : (
                        <FaLock style={{ width: "24px", height: "24px" }} />
                      )
                    ) : (
                      <FaUnlock style={{ width: "24px", height: "24px" }} />
                    )
                  ) : (
                    <FaUnlock style={{ width: "24px", height: "24px" }} />
                  )
                ) : (
                  <FaUnlock style={{ width: "24px", height: "24px" }} />
                )}
              </button>
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "Sessions",
        accessor: "NumberOfSessions", // accessor is the "key" in the data
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {row.original.Status === "Online"
                ? row.original.NumberOfSessions
                : "–"}
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "Alarms",
        accessor: "Alarms", // accessor is the "key" in the data
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {row.original.Status === "Online" ? row.original.Alarms : "–"}
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "Shutdowns",
        accessor: "Shutdowns", // accessor is the "key" in the data
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {row.original.Status === "Online" ? row.original.Shutdowns : "–"}
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "Last Active",
        accessor: "lastActive", // accessor is the "key" in the data
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {row.original.Status === "Online" ? row.original.lastActive : "–"}
            </div>
          );
        },
        isVisible: true,
      },
      {
        Header: "Ambient Temp (°C)",
        accessor: "ambientTemp", // accessor is the "key" in the data
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {row.original.Status === "Online" ? row.original.ambientTemp : "–"}
            </div>
          );
        },
        isVisible: true,
      },
    ],
    [tableUpdateFlag]
  );

  async function handleTurnOffStove(sensorid) {
      console.log(`Turning off stove for unit: ${sensorid}`);
      setLoading(true);
      let newTableData = result.map((item) => { 
          if (item.SensorID === sensorid) {
              return {
                  ...item,
                  stoveStatus: 'OFF',
                  IsStoveRemoteUnlocked: "LOCKED"
              }
          }
          return item;
      });
      setResult(newTableData);
      setTimeout(() => {
        setTableUpdateFlag(!tableUpdateFlag);
      }, 2000) 
  }

  async function handleStoveRemoteUnlock(sensorid){
      console.log(`Unlocking stove for unit: ${sensorid}`);
      setLoading(true);
      let newTableData = result.map((item) => {
        if (item.SensorID === sensorid) {
          return {
            ...item,
            IsStoveRemoteUnlocked: "UNLOCKED",
          };
        }
        return item;
      });
      setResult(newTableData);
      setTimeout(() => {
        setTableUpdateFlag(!tableUpdateFlag);
      }, 2000); 
  }



  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      //fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );
//   console.log(`tabledata = ${JSON.stringify(result, null, 2)}`);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    preGlobalFilteredRows,
    setGlobalFilter,
    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, hiddenColumns },
    //Added TS ignore Outdated ts support in for this library
    // @ts-ignore
  } = useTable(
    {
      columns,
      data: result,
      initialState: {
        hiddenColumns: columns.filter((column) => !column.isVisible).map((column) => column.accessor),
        sortBy: [{ id: "UnitNumber" }],
        pageIndex: 0,
      },
      filterTypes,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const buttonStyles = {
    backgroundColor: "#45a049",
    display: "inline-flex", // Important for inline alignment
    alignItems: "center", // Vertically center content
    gap: "8px", // Space between image and text
    color: "white",
    fontWeight: "bold",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "5px",
    //    display: "inline-block",
    //    width: '100%',
    transition: "all 0.1s ease", // Add transition here
    boxShadow:
      "4px 4px 8px rgba(0, 0, 0, 0.9), 1px 1px 0px rgba(255, 255, 255, 0.2) inset",
  };

  const activeStyles = {
    transform: 'translateY(2px)',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.2) inset', // Or adjust as needed
  };

  const hoverStyles = {
    boxShadow:
      "5px 5px 10px rgba(0, 0, 0, 1), 2px 2px 0px rgba(255, 255, 255, 0.3) inset",
    backgroundColor: "rgb(99, 190, 103)",
  };

 const handleMouseDown = (index) => {
  setButtonStates(prevStates => {
    const newStates = [...prevStates];
    newStates[index].isPressed = true;
    return newStates;
  });
};

const handleMouseUp = (index) => {
  setButtonStates(prevStates => {
    const newStates = [...prevStates];
    newStates[index].isPressed = false;
    return newStates;
  });
};

const handleMouseEnter = (index) => {
  setButtonStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index].isHovered = true;
      return newStates;
    });
};

const handleMouseLeave = (index) => {
  setButtonStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index].isPressed = false;
      newStates[index].isHovered = false;
      return newStates;
    });
};

const delay = (ms) => new Promise(res => setTimeout(res, ms)); // Helper function


const handleClick = async (label, index) => {
  switch (label) {
    case "refresh":
      // Refresh logic  
      console.log("Refreshing...");
      setLoading(true);
      await delay(1000); // Wait for the delay
      setTableUpdateFlag(!tableUpdateFlag); // Example: Toggle table update flag
      break;
    case 'Power off all stoves':
      // Turn off all stoves logic
      console.log("Turning off all stoves...");
      setLoading(true);
          
      let offTableData = result.map((item) => {
        if (item.Status === "Online" && item.isPCOconnected === "YES" && item.stoveStatus === "ON") {
            return {
              ...item,
              stoveStatus: "OFF",
              IsStoveRemoteUnlocked: "LOCKED",
            };
        }
        return item;
      });
        
      setResult(offTableData);
      setTimeout(() => {
        setTableUpdateFlag(!tableUpdateFlag);
      }, 2000); 
      // ... your code to turn off stoves
      break;
    case 'Unlock all stoves':
      setLoading(true);

      let unlockedTableData = result.map((item) => {
        if (
          item.Status === "Online" &&
          item.isPCOconnected === "YES" &&
          item.stoveStatus === "OFF" &&
          item.IsStoveRemoteUnlocked === "LOCKED"
        ) {
           return {
             ...item,
             IsStoveRemoteUnlocked: "UNLOCKED",
           };
        }
        return item;
      });
          
      setResult(unlockedTableData);
      setTimeout(() => {
        setTableUpdateFlag(!tableUpdateFlag);
      }, 2000); 
      // Unlock all stoves logic
      console.log("Unlocking all stoves...");
      // ... your code to unlock stoves
      break;
    default:
      console.log("Unknown button clicked:", label);
      break;
  }
    
    setButtonStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index].isPressed = false;
      newStates[index].isHovered = false;
      return newStates;
    });
};

const buttons = [
  {
    label: "refresh",
    text: <span style={{ verticalAlign: "top" }}>Refresh</span>,
    img: <IoMdRefreshCircle style={{ width: "30px", height: "30px" }} />,
  },
  {
    label: "Power off all stoves",
    text: <span style={{ verticalAlign: "middle" }}>Power off all stoves</span>,
    img: <LuCirclePower style={{ width: "30px", height: "30px" }} />,
  },
  {
    label: "Unlock all stoves",
    text: <span style={{ verticalAlign: "middle" }}>Unlock all stoves</span>,
    img: <FaUnlock style={{ width: "25px", height: "25px" }} />,
  },
];
    
const totalAlarms = result.reduce((acc, item) => acc + (item.Status === "Offline" ? 0 : item.Alarms), 0);
const totalOffline = result.reduce(
  (acc, item) => acc + (item.Status === "Offline" ? 1 : 0),
  0
);
const totalStovesOff = result.reduce(
  (acc, item) =>
    acc +
    (item.stoveStatus == "OFF" &&
    item.PCOFWVersion !== "NULL" &&
    item.Status === "Online"
      ? 1
      : 0),
  0
);
    
const totalShutdown = result.reduce(
  (acc, item) => acc + (item.Status === "Offline" ? 0 : item.Shutdowns),
  0
);

  if (!loading && CtsConfig && result && result.length > 0 && columns && columns.length > 0) {
 
  return (
    <>
      <div className="container m-auto mt-6">
        <h1 className="text-2xl">
          <span
            style={{
              background: "rgba(238, 238, 238, 0.7)",
            }}
          >
            {" "}
            {props.building.name}
          </span>
        </h1>
        <div className="container-infobox">
          <div className="info-textbox">
            <IconContext.Provider
              value={{ color: "grey", className: "global-class-name" }}
            >
              <IoCloudOffline className="icon" />
            </IconContext.Provider>
            <span>{totalOffline}</span> <h2>Offline </h2>
          </div>
          <div className="info-textbox">
            <IconContext.Provider
              value={{ color: "#26496c", className: "global-class-name" }}
            >
              <PiCookingPotFill className="icon" />
            </IconContext.Provider>
            <span>{totalStovesOff}</span> <h2>Powered Off </h2>
          </div>
          <div className="info-textbox">
            <IconContext.Provider
              value={{ color: "#E25822", className: "global-class-name" }}
            >
              <ImFire className="icon" />
            </IconContext.Provider>
            <span>{totalAlarms}</span> <h2>Alarms </h2>
          </div>
          <div className="info-textbox">
            <IconContext.Provider
              value={{ color: "#3b3b3b", className: "global-class-name" }}
            >
              <FaPlug className="icon" />
            </IconContext.Provider>
            <span>{totalShutdown}</span> <h2>Shutdowns </h2>
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", height: "40px" }}>
          {buttons.map((button, index) => (
            <button
              key={index} // Important: Add a unique key for each button
              disabled={false}
              style={{
                ...buttonStyles,
                ...(buttonStates[index].isPressed ? activeStyles : {}),
                ...(buttonStates[index].isHovered ? hoverStyles : {}),
              }}
              onMouseDown={() => handleMouseDown(index)}
              onMouseUp={() => handleMouseUp(index)}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={() => handleMouseLeave(index)}
              onClick={() => handleClick(button.label, index)}
            >
              {button.img}
              {button.text}
            </button>
          ))}
        </div>

        <div style={{ height: "20px" }} />
        <div className="container-layout">
          <div>
            <table
              className="drop-shadow-lg"
              {...getTableProps()}
              style={{ border: "solid 1px black" }}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => {
                      return (
                        <th
                          // @ts-ignore
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{
                            borderBottom: "solid 3px black",
                            background: "white",
                            color: "black",
                            fontWeight: "bold",
                            padding: "10px",
                          }}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " 🔽"
                                : " 🔼"
                              : ""}
                          </span>
                        </th>
                      );
                    })}
                  </tr>
                ))}
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                    }}
                  >
                    <GlobalFilter
                      preGlobalFilteredRows={preGlobalFilteredRows}
                      setGlobalFilter={setGlobalFilter}
                    />
                  </th>
                </tr>
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            style={{
                              padding: "10px",
                              border: "solid 1px gray",
                              background: i % 2 === 0 ? "#EEEEEE" : "white",
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {/* 
          Pagination can be built however you'd like. 
          This is just a very basic UI implementation:
        */}

            <div className="pagination">
              <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                {"<<"}
              </button>{" "}
              <button
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>{" "}
              <>
                {Array.from({ length: 5 }, (_, i) => {
                  const pageNumber = pageIndex + 1 + i;
                  const isDisabled = pageNumber > pageOptions.length;

                  return (
                    <button
                      key={pageNumber}
                      disabled={isDisabled}
                      onClick={() => !isDisabled && gotoPage(pageNumber - 1)}
                    >
                      {pageNumber}
                    </button>
                  );
                })}
              </>
              <button onClick={() => nextPage()} disabled={!canNextPage}>
                {">"}
              </button>{" "}
              <button
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>{" "}
              {/* <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[10, 20, 30, 40, 50].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select> */}
            </div>
            {/* END OF Pagination */}
          </div>
          <div className="map">
            <Map data={[props.building]} center={center} />
          </div>
        </div>
      </div>
    </>
  );
  } else if (loading) {
    return <Loader/>;
  } else {
    return <p>Error</p>;
  }
}